import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'

import { Event } from '../../../../../../../../../entities/Event'

import './RelatedEventsItem.css'

const RelatedEventsItem = ({ relatedEvent }) => {
    const {
        slug,
        displayDate,
        truncatedTitle,
        htmlContentShortTruncated,
        truncatedTitleMobile
    } = relatedEvent

    return (
        <Link to={`/dogadjaj/${slug}`} className="related-event-item">
            <h6>{displayDate}</h6>
            <h5 className="related-event-item__truncatedTitle">{truncatedTitle}</h5>
            <h5 className="related-event-item__truncatedTitle--mobile">{truncatedTitleMobile}</h5>
            <div
                className="related-event-item__text"
                dangerouslySetInnerHTML={htmlContentShortTruncated}
            />
        </Link>
    )
}

RelatedEventsItem.propTypes = {
    relatedEvent: PropTypes.instanceOf(Event).isRequired
}

export { RelatedEventsItem }
